import Api from '../../api/organizations'

export default {
  namespaced: true,
  state: {
    listPage: null
  },
  getters: {
  },
  mutations: {
    setListPage(state, page) {
      state.listPage = page
    }
  },
  actions: {
    searchOrganizations(context, request) {
      return Api.search(request).then(function (response) {
        context.commit('setListPage', response.data)
      });
    }
  },
  modules: {
  }
}